import _JSON$stringify from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/core-js/json/stringify';
import _extends from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/extends';
import _regeneratorRuntime from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CreateNewModuleSessionForm from '~/components/dashboard/management/CreateNewModuleSessionForm.vue';
import BulkyCreateNewModuleSession from '~/components/dashboard/management/BulkyCreateNewModuleSession.vue';
import BulkyRegister from '~/components/dashboard/management/bulkyRegister.vue';
import RegisterApplicant from '~/components/Register.vue';
import EditUserPanel from '~/components/dashboard/management/EditUserPanel.vue';
import AddNewModule from '~/components/dashboard/management/addNewModule.vue';
import AddNewLanguage from '~/components/dashboard/management/addNewLanguage.vue';
import PendingApproveEditUserInfo from '~/components/dashboard/management/PendingApproveEditUserInfo.vue';

import axios from '~/plugins/axios.js';
import domain from '~/plugins/domain.js';

export default {
  layout: 'dashBoardLayout',
  name: 'management',
  components: {
    EditUserPanel: EditUserPanel,
    CreateNewModuleSessionForm: CreateNewModuleSessionForm,
    PendingApproveEditUserInfo: PendingApproveEditUserInfo,
    BulkyCreateNewModuleSession: BulkyCreateNewModuleSession,
    BulkyRegister: BulkyRegister,
    RegisterApplicant: RegisterApplicant,
    AddNewModule: AddNewModule,
    AddNewLanguage: AddNewLanguage
  },
  data: function data() {
    return {
      regUserTabIdx: 0,
      createMsTabIdx: 0,
      userRegInfoOverwrite: {}
    };
  },
  fetch: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var store = _ref.store,
          redirect = _ref.redirect;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (store.state.authUser) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return', redirect('/'));

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function fetch(_x) {
      return _ref2.apply(this, arguments);
    }

    return fetch;
  }(),


  methods: {
    msLinkClass: function msLinkClass(idx) {
      if (this.createMsTabIdx === idx) {
        return ['bg-dark', 'text-light'];
      } else {
        return ['bg-light', 'text-dark'];
      }
    },
    linkClass: function linkClass(idx) {
      if (this.regUserTabIdx === idx) {
        return ['bg-dark', 'text-light'];
      } else {
        return ['bg-light', 'text-dark'];
      }
    },
    createNewModuleSession: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(moduleInfo) {
        var moduleInfoSub, _ref4, data;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('\n\n===== From Management Index Page ======\n', moduleInfo, '\n============');

                moduleInfoSub = _extends({}, moduleInfo, {
                  adminActorId: this.$store.state.authUserActorId
                });
                _context2.next = 4;
                return axios.post('/domain/ModuleSession/create', moduleInfoSub);

              case 4:
                _ref4 = _context2.sent;
                data = _ref4.data;

                if (data.hasOwnProperty('error')) {
                  window.alert(_JSON$stringify(_extends({}, data.error)));
                } else {
                  window.alert('New Module Session Created Successfully');
                }

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function createNewModuleSession(_x2) {
        return _ref3.apply(this, arguments);
      }

      return createNewModuleSession;
    }(),
    bulkyModuleSessionCreate: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(moduleSessionList) {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.$store.commit('management/clearBulkyCreateMsList');
                console.log('\n\n ===== ManagementComp <|-- bulkyModuleSessionCreate() ===== \n', moduleSessionList, '\n -------------------------');

                // let dataReturned = [];

                moduleSessionList.forEach(function () {
                  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(moduleSession) {
                    var createInfoReturned;
                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return axios.post('/moduleSession/bulkyModuleSessionCreate', { moduleSession: moduleSession });

                          case 2:
                            createInfoReturned = _context3.sent;


                            _this.$store.commit('management/addBulkyCreateMsList', {
                              dataReturned: createInfoReturned.data
                            });
                            // }

                          case 4:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this);
                  }));

                  return function (_x4) {
                    return _ref6.apply(this, arguments);
                  };
                }());

                // console.log('\n\n ===== ManagementComp <|-- bulkyModuleSessionCreate()dataReturned ===== \n',
                // dataReturned, '\n -------------------------');

                console.log('\n\n ===== ManagementComp <|-- bulkyModuleSessionCreate() $store.bulkyCreateMsList ===== \n', this.$store.state.management.bulkyCreateMsList, '\n ----------------------- ');

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function bulkyModuleSessionCreate(_x3) {
        return _ref5.apply(this, arguments);
      }

      return bulkyModuleSessionCreate;
    }(),
    registerApplicant: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(userRegisterInfo) {
        var username, password, confirmPassword, fullname, companyName, conEmail, dateOfBirth, nricFin, idType, _ref8, data;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                console.log('\n\n ========= From Manager Index Page ========\n', userRegisterInfo, '\n ========');

                username = userRegisterInfo.username, password = userRegisterInfo.password, confirmPassword = userRegisterInfo.confirmPassword, fullname = userRegisterInfo.fullname, companyName = userRegisterInfo.companyName, conEmail = userRegisterInfo.conEmail, dateOfBirth = userRegisterInfo.dateOfBirth, nricFin = userRegisterInfo.nricFin, idType = userRegisterInfo.idType;

                this.userRegInfoOverwrite = {
                  username: username,
                  password: password,
                  confirmPassword: confirmPassword,
                  fullname: fullname,
                  companyName: companyName,
                  conEmail: conEmail,
                  dateOfBirth: dateOfBirth,
                  nricFin: nricFin,
                  idType: idType,
                  adminActorId: this.$store.state.authUserActorId,
                  flag: 'Wkr'
                };
                console.log('\n\n ========= From Manager Index Page userRegInfoOverwrite========\n', this.userRegInfoOverwrite, '\n ========');

                _context5.next = 6;
                return axios.post('/domain/User/create', this.userRegInfoOverwrite);

              case 6:
                _ref8 = _context5.sent;
                data = _ref8.data;

                console.log('\n\n ======New Worker Reg from Management ========\n', data, '\n ============');

                if (data.hasOwnProperty('error')) {
                  window.alert(_JSON$stringify(_extends({}, data.error)));
                }

              case 10:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function registerApplicant(_x5) {
        return _ref7.apply(this, arguments);
      }

      return registerApplicant;
    }(),


    // ========== bulky registration ==========
    bulkyRegistration: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(workerUserList) {
        var bulkyRegInfo;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                console.log('\n\n ========= index.vue workerUserList ===========\n', workerUserList, '\n -----------------------');

                _context6.next = 3;
                return axios.post('/users/bulkyRegistration', workerUserList);

              case 3:
                bulkyRegInfo = _context6.sent.data;


                console.log('\n\n ========= index.vue bulkyRegInfo\n =========', bulkyRegInfo, '\n -----------------------');
                this.$store.commit('management/setBulkyRegUserList', bulkyRegInfo);

              case 6:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function bulkyRegistration(_x6) {
        return _ref9.apply(this, arguments);
      }

      return bulkyRegistration;
    }(),
    addNewModule: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(moduleName) {
        var newModule;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (moduleName) {
                  _context7.next = 4;
                  break;
                }

                alert('No Input');
                _context7.next = 10;
                break;

              case 4:
                console.log('\n\n ========= Management <|-- addNewModule() ========\n', moduleName, '\n ========');

                _context7.next = 7;
                return axios.post('/managing/addNewModule', {
                  fields: 'Module',
                  content: moduleName
                });

              case 7:
                newModule = _context7.sent.data;


                console.log('\n\n =========  From addNewModule newModule========\n', newModule, '\n -----------------------');
                alert(newModule);
                //
                // this.$store.commit('management/addNewModule', {moduleName});

              case 10:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function addNewModule(_x7) {
        return _ref10.apply(this, arguments);
      }

      return addNewModule;
    }(),
    removeModuleName: function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(moduleName) {
        var returnedInfoRemoved;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                console.log('\n\n ========== Management <| removeModuleName, receive from comp Add New Modules ==========\n', moduleName, '\n -----------------');
                _context8.next = 3;
                return axios.post('/managing/removeModuleNames', { moduleName: moduleName });

              case 3:
                returnedInfoRemoved = _context8.sent.data;

                //
                console.log('\n\n ======== Management <| removeModuleName returnedInfoRemoved =======\n', returnedInfoRemoved, '\n ----------------');

              case 5:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function removeModuleName(_x8) {
        return _ref11.apply(this, arguments);
      }

      return removeModuleName;
    }(),
    addNewLanguage: function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(language) {
        var newLang;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (language) {
                  _context9.next = 4;
                  break;
                }

                alert('No Input');
                _context9.next = 10;
                break;

              case 4:
                console.log('\n\n ========= From Manager language ========\n', language, '\n ========');
                _context9.next = 7;
                return axios.post('/managing/addNewLanguage', {
                  fields: 'Language',
                  content: language
                });

              case 7:
                newLang = _context9.sent.data;

                console.log('\n\n ========= From addNewModule newLanguage ========\n', newLang, '\n -----------------------');
                alert(newLang);

              case 10:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function addNewLanguage(_x9) {
        return _ref12.apply(this, arguments);
      }

      return addNewLanguage;
    }(),
    removeLanguages: function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(language) {
        var returnedInfoRemoved;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                console.log('\n\n ========== Management <| removeLanguages, receive from comp Add New Lang ==========\n', language, '\n -----------------');

                _context10.next = 3;
                return axios.post('/managing/removeLanguages', { language: language });

              case 3:
                returnedInfoRemoved = _context10.sent.data;

                console.log('\n\n ======== From remove Languages ========\n', returnedInfoRemoved, '\n ------------------');

              case 5:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function removeLanguages(_x10) {
        return _ref13.apply(this, arguments);
      }

      return removeLanguages;
    }()
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/dashboard/management/index.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/dashboard/management/index.vue
// module chunks = 0